module.exports = __webpack_public_path__ + "img/chart.2dc337b0.jpg";